"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhotoStatus = void 0;
var PhotoStatus;
(function (PhotoStatus) {
    PhotoStatus["NEW"] = "NEW";
    PhotoStatus["APPROVED"] = "APPROVED";
    PhotoStatus["DECLINED"] = "DECLINED";
})(PhotoStatus || (exports.PhotoStatus = PhotoStatus = {}));
//# sourceMappingURL=photo.js.map